<template>
	<div>
		<!-- 图片 -->
		<el-image class="pbg" :src="require('@/static/icon1.jpg')"></el-image>
		<div class="pagename">海南‮燃省‬气从业人‮培员‬训教育‮息信‬平台</div>
		<!-- 登录框 -->
		<div class="loginform animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="backPage" @click="link('/home')">返回网站首页</div>
			<div class="lLogo">
				<el-image class="logoBG" :src="require('@/static/icon2bg.jpg')"></el-image>
				<el-image class="logo" :src="require('@/static/icon2.png')"></el-image>
			</div>
			<div class="rForm">
				<p class="tit">欢迎登录</p>
				<div class="bor"></div>
				<div class="identity f-ct">
					<div class="itm f-ct" @click="userType=1" :class="userType==1?'a':''">
						<el-image v-if="userType==1" :src="require('@/static/icon3h.png')"></el-image>
						<el-image v-else :src="require('@/static/icon3.png')"></el-image>
						<p>学员用户</p>
					</div>
					<div class="itm f-ct" @click="userType=2" :class="userType==2?'a':''">
						<el-image v-if="userType==2" :src="require('@/static/icon4h.png')"></el-image>
						<el-image v-else :src="require('@/static/icon4.png')"></el-image>
						<p>企业用户</p>
					</div>
				</div>
				<div class="ipt">
					<el-image :src="require('@/static/icon5.png')"></el-image>
					<div class="bor1"></div>
					<el-input type="text" v-model="mobile" placeholder="手机号"></el-input>
				</div>
				<div class="ipt" v-if="loginType==1">
					<el-image :src="require('@/static/icon6.png')"></el-image>
					<div class="bor1"></div>
					<el-input type="password" v-model="password" placeholder="登录密码"></el-input>
				</div>
				<div class="ipt code" v-if="loginType==0">
					<el-image :src="require('@/static/icon6.png')"></el-image>
					<div class="bor1"></div>
					<el-input type="text" v-model="code" placeholder="验证码"></el-input>
					<div class="codeTxt" @click="authMemberregCaptcha">{{codetxt}}</div>
				</div>
				<div class="tipsPwd" @click="loginType=0" v-if="loginType==1">验证码登录</div>
				<div class="tipsPwd" @click="loginType=1" v-if="loginType==0">账号密码登录</div>
				
				<div class="anniu" v-if="loginType==1" @click="authMemberloginByPassword">登录</div>
				<div class="anniu" v-if="loginType==0" @click="authMemberloginByPasswordCode">登录</div>
				
				<div class="wjmm" @click="link('/cpwd')">忘记密码</div>
				<div class="tips">还没有账号<p @click="link('/reg')">立即注册</p></div>
			</div>
		</div>
		<!-- 底部文字 -->
		<div class="baTxt">Copright @2017 Corporation AII Rights Reservde 琼ICP备18003071号-2 海南省燃气协会网支持IPv6网络</div>
	</div>
</template>
<script>
import { authMemberloginByPassword,authCompanyloginByPassword,authMemberInfo,authCompanyInfo,
authMemberregCaptcha,
authMemberloginByPasswordQY,
authCompanyloginByPasswordQY
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
let that;
let ic;
var nub = 120;
export default {
	components:{},
	data(){
		return {
			userType:1,
			mobile:'',
			password:'',
			code:'',
			loginType:1,
			codetxt:'发送验证码',
		}
	},
	mounted() {
		that = this
		// console.log(this.$route.query)
	},
	methods:{
		// 验证码 登录
		async authMemberloginByPasswordCode(){
			let res;
			// 学员
			if(this.userType==1){
				res = await authMemberloginByPasswordQY({
					mobile:this.mobile,
					code:this.code,
				});
			}
			// 企业
			if(this.userType==2){
				res = await authCompanyloginByPasswordQY({
					mobile:this.mobile,
					code:this.code,
				});
			}
			if(res.code==200){
				this.$store.commit('userMsg/tokenC',res.msg);
				this.getinfo()
			}else{this.Tips(res.msg,'error')}
		},
		// 手机号密码登录
		async authMemberloginByPassword(){
			let res;
			// 学员
			if(this.userType==1){
				res = await authMemberloginByPassword({
					mobile:this.mobile,
					password:this.password,
				});
			}
			// 企业
			if(this.userType==2){
				res = await authCompanyloginByPassword({
					mobile:this.mobile,
					password:this.password,
				});
			}
			if(res.code==200){
				this.$store.commit('userMsg/tokenC',res.msg);
				this.getinfo()
			}else{this.Tips(res.msg,'error')}
		},
		// 获取用户信息
		async getinfo(){
			let res;
			// 学员
			if(this.userType==1){
				res = await authMemberInfo({});
			}
			// 企业
			if(this.userType==2){
				res = await authCompanyInfo({});
			}
			if(res.code==200){
				
				
				
				
				this.$store.commit('userMsg/userInfoC',res.data);
				// 账号类型
				this.$store.commit('userMsg/userTypeC',this.userType);
				
				if(this.userType==1){
					if(res.data.company.status==1){
						this.Tips('企业信息异常','error')
						setTimeout(()=>{
							this.link('/qyInfoRemake')
						},1500)
					}else{
						this.Tips('登录成功','success')
						setTimeout(()=>{
							this.link('/userHome')
						},1500)
					}
				}else{
					this.Tips('登录成功','success')
					setTimeout(()=>{
						this.link('/userHome')
					},1500)
				}
				
				
			}else{this.Tips(res.msg,'error')}
		},
		// 验证码
		async authMemberregCaptcha(){
			var that = this
			if(!this.checkModbile(this.mobile)){
				this.Tips('请输入正确的手机号','error')
				return
			}
			let res = await authMemberregCaptcha({mobile:this.mobile});
			if(res.code==200){
				this.Tips(res.msg,'success')
				nub = 120
				ic = setInterval(()=>{
					nub--
					that.codetxt = nub+'s'
					if(nub<=0){
						that.codetxt = '发送验证码'
						clearInterval(ic)
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		checkModbile(mobile) {
			var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
			var result = re.test(mobile); 
			if(!result) {
				return false;//若手机号码格式不正确则返回false
				}
			return true;
		},
		/***************** vuex实例 *************************/
		
		// 直接走mutations修改
		// add(){
		    // const obj = {id:nanoid(),name:this.name}
		    // this.name = ''
		    // this.$store.commit('persionPosion/ADD_PERSON',obj)
			// 直接走mutations修改
		// },
		
		// 走actio计算后走mutations修改
		// addw(){
		    // const obj = {id:nanoid(),name:this.name}
		    // this.name = ''
		    // this.$store.dispatch('persionPosion/addW',obj)
			// 走actio计算后走mutations修改
		// },
		
		// 直接拿出函数
		// ...mapMutations('userMsg',{increment:'JIA',decrement:'JIAN'}),
		// ...mapActions('userMsg',{incrementOdd:'odd_jia',incrementWait:'wait_jia'}),
	},
	computed:{
		...mapState('userMsg',['userInfo']),
		/***************** vuex实例 *************************/
		
		// 把userMsg的state全拿出来
		// ...mapState(['userMsg']),
		
	    // 单个拿出
	    // ...mapState('userMsg',['sum']),
	    // ...mapState('persionPosion',['Persons']),
		
		// 拿vuex 计算属性
	    // ...mapGetters('persionPosion',['Persons_sum']),
	    // Persons_sum(){
	    //     return this.$store.getters['persionPosion/Persons_sum']
	    // },
	}
}
</script>
<style lang="scss">
body{
	background: #F5F5F5;
}
</style>
<style lang="scss" scoped>
.page{
	position: relative;
}
.wjmm{
	color: #999999;
	margin-top: 16px;
	text-align: center;
	font-size: 14px;
}
.pagename{
	position: fixed;
	z-index: 2;
	top: 0;
	left: 0;
	color: #3B6492;
	text-align: center;
	width: 100%;
	top: 60px;
	font-size: 32px;
	font-weight: bold;
}
.pbg{
	width: 1920px;
	height: 1080px;
	display: block!important;
	position: fixed;
}
.loginform{
	position: fixed;
	top: 50%;
	left: 50%;
	background: #fff;
	transform: translateY(-50%)translateX(-50%);
	width: 1000px;
	height: 600px;
	display: flex;
	align-items: center;
	.backPage{
		position: absolute;
		left: 0;
		top: -32px;
		color: #3B6492;
		text-decoration: underline;
		font-size: 14px;
		cursor: pointer;
	}
	.lLogo{
		width: 500px;
		height: 600px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		.logoBG{
			width: 500px;
			height: 600px;
			position: absolute;
			left: 0;
			top: 0;
		}
		.logo{
			width: 314px;
			height: 314px;
			position: relative;
			z-index: 2;
		}
	}
	.rForm{
		width: 500px;
		height: 600px;
		.tit{
			padding-top: 75px;
			padding-bottom: 15px;
			color: #3B6492;
			font-size: 24px;
			text-align: center;
		}
		.bor{
			margin: auto;
			width: 26px;
			height: 6px;
			background: #3B6492;
			margin-bottom: 32px;
		}
		.identity{
			display: flex;
			justify-content: space-between;align-items: center;
			margin: auto;
			margin-bottom: 20px;
			width: 350px;
			.itm{
				width: 170px;
				height: 72px;
				justify-content: center;
				border: 1px solid #DEDEDE;
				cursor: pointer;
				.el-image{
					width: 40px;
					height: 40px;
					margin-right: 12px;
				}
				text{
					font-size: 14px;
					color: #666666;
				}
			}
			.a{
				border: 1px solid #3B6492;
				text{
					color: #3B6492;
				}
			}
		}
		.code{
			.el-input{
				width: calc(100% - 120px)!important;
			}
			.codeTxt{
				color: #3B6492;
				font-size: 14px;
				cursor: pointer;
				width: 120px;
				text-align: center;
			}
		}
		.ipt{
			width: 350px;
			height: 40px;
			margin: auto;
			border: 1px solid #DDDDDD;
			margin-bottom: 20px;
			padding-left: 12px;
			display: flex;
			align-items: center;
			.el-image{
				width: 24px;
				height: 24px;
				margin-right: 12px;
			}
			.bor1{
				width: 1px;
				height: 16px;
				background: #DDDDDD;
			}
			.el-input{
				width: calc(100% - 37px);
			}
			::v-deep .el-input__inner{
				
				height: 40px;
				border: none;
				background: transparent;
			}
		}
		.tipsPwd{
			font-size: 14px;
			color: #333333;
			margin-bottom: 25px;
			padding-right: 75px;
			text-align: right;
			cursor: pointer;
		}
		.anniu{
			width: 350px;
			height: 40px;
			margin: auto;
			line-height: 40px;
			background: #3B6492;
			font-size: 16px;
			color: #FFFFFF;
			letter-spacing: 2px;
			text-align: center;
			cursor: pointer;
		}
		.tips{
			font-size: 14px;
			text-align: center;
			margin-top: 68px;
			p{
				color: #3B6492;
				padding-left: 4px;
				display: inline-block;
				cursor: pointer;
			}
		}
	}
}
</style>